var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "JUNE_ICONS",
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22.04,24.73l-2.94-2.94-1.63,1.63,4.57,4.57,8.32-8.32-1.63-1.63-6.7,6.7Zm0,15.39l-2.94-2.94-1.63,1.63,4.57,4.57,8.32-8.32-1.63-1.63-6.7,6.7ZM58.5,4.53h-11.78V1.15c0-.64-.52-1.15-1.15-1.15h-19.13c-.63,0-1.15.51-1.15,1.15v3.38h-11.78c-.63,0-1.15.51-1.15,1.15v65.17c0,.64.52,1.15,1.15,1.15h45c.63,0,1.15-.51,1.15-1.15V5.68c0-.64-.52-1.15-1.15-1.15Zm-30.91-2.23h16.83v6.76h-16.83V2.3Zm29.76,67.4H14.65V6.83h10.63v3.38c0,.64.52,1.15,1.15,1.15h19.13c.63,0,1.15-.51,1.15-1.15v-3.38h10.63v62.87Zm-22.34-45.94h18.75v-2.3h-18.75v2.3Zm0,16.04h18.75v-2.3h-18.75v2.3Zm0,16.04h18.75v-2.3h-18.75v2.3Zm-6.06-7.33h-10.06c-.63,0-1.15.51-1.15,1.15v10.06c0,.64.52,1.15,1.15,1.15h10.06c.63,0,1.15-.51,1.15-1.15v-10.06c0-.64-.52-1.15-1.15-1.15Zm-1.15,10.06h-7.76v-7.76h7.76v7.76Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon4.ea1c83b5bda01a05b880f524e5a1af42.svg";
export { ForwardRef as ReactComponent };